import React from "react";

export default function AvatarShimmer({ count = 8 }) {
  return (
    <div className="grid grid-cols-4 gap-3 border rounded-xl p-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl shimmer animate-pulse"
        ></div>
      ))}
    </div>
  );
}
